import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';
import { PortalProvider } from '@gorhom/portal';
import VLOCContextProvider from 'features/lineOfCredit/providers/VLOCContextProvider/VLOCContextProvider';
import { TabaPayAddressProvider } from 'features/moveMoney/screens/dcf/tabapay/providers/TabaPayContextProvider';
import MyVaroContextProvider from 'features/myVaro/provider/MyVaroContextProvider';
import RDCContextProvider from 'features/rdc/providers/RDCContextProvider/RDCContextProvider';
import { SelfFundedOfferContextProvider } from 'features/rewards/SelfFundedOffers/ContextProvider/SelfFundedOfferContextProvider';
import { UrlDocumentContextProvider } from 'features/urlDocumentScreens/UrlDocumentContext/UrlDocumentContext';
import { V2AReceiverContextProvider } from 'features/v2a/receiver/providers/V2AReceiverContextProvider';
import { V2AContextProvider } from 'features/v2a/sender/provider/V2AContextProvider';
import React, { PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';
import { KeyboardProvider } from 'react-native-keyboard-controller';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import AmplitudeSessionReplay from 'shared/components/AmplitudeSessionReplay/AmplitudeSessionReplay';
import AnalyticsSetup from 'shared/components/AnalyticsSetup/AnalyticsSetup';
import NetworkStatus from 'shared/components/NetworkStatus/NetworkStatus';
import OtaUpdateBanner from 'shared/components/OtaUpdateBanner/OtaUpdateBanner';
import localizationManager from 'shared/localization/localizationManager';
import CrossPlatformAnalyticsProvider from 'shared/providers/analytics/AnalyticsContext';
import AuthProvider from 'shared/providers/auth';
import { EngagementProvider } from 'shared/providers/engagementProvider/EngagementProvider';
import EnvironmentProvider from 'shared/providers/environment';
import GlobalUIContextProvider from 'shared/providers/globalUIProvider/GlobalUIContextProvider/GlobalUIContextProvider';
import { IdleTimeoutProvider } from 'shared/providers/IdleTimeoutContext';
import { InitializationProvider } from 'shared/providers/initialization/InitializationProvider';
import { CrossPlatformStatsigProvider } from 'shared/providers/statsig/StatsigContext';
import UrqlProvider from 'shared/providers/urql';

const Providers = ({ children }: PropsWithChildren) => {
  return (
    <KeyboardProvider>
      <EnvironmentProvider>
        <InitializationProvider>
          {/* TODO: Eventually remove these top-level providers once feature teams migrate away from context consumption */}
          <CrossPlatformAnalyticsProvider>
            <CrossPlatformStatsigProvider>
              <AmplitudeSessionReplay />
              <AnalyticsSetup />
              <NetworkStatus />
              <AuthProvider>
                <IdleTimeoutProvider>
                  <UrqlProvider>
                    <EngagementProvider>
                      <I18nextProvider i18n={localizationManager}>
                        <GlobalUIContextProvider>
                          <PortalProvider>
                            <BottomSheetModalProvider>
                              <VLOCContextProvider>
                                <V2AContextProvider>
                                  <RDCContextProvider>
                                    <UrlDocumentContextProvider>
                                      <MyVaroContextProvider>
                                        <SafeAreaProvider>
                                          <TabaPayAddressProvider>
                                            <V2AReceiverContextProvider>
                                              <SelfFundedOfferContextProvider>
                                                {children}
                                                <OtaUpdateBanner />
                                              </SelfFundedOfferContextProvider>
                                            </V2AReceiverContextProvider>
                                          </TabaPayAddressProvider>
                                        </SafeAreaProvider>
                                      </MyVaroContextProvider>
                                    </UrlDocumentContextProvider>
                                  </RDCContextProvider>
                                </V2AContextProvider>
                              </VLOCContextProvider>
                            </BottomSheetModalProvider>
                          </PortalProvider>
                        </GlobalUIContextProvider>
                      </I18nextProvider>
                    </EngagementProvider>
                  </UrqlProvider>
                </IdleTimeoutProvider>
              </AuthProvider>
            </CrossPlatformStatsigProvider>
          </CrossPlatformAnalyticsProvider>
        </InitializationProvider>
      </EnvironmentProvider>
    </KeyboardProvider>
  );
};

export default Providers;
